import React, {useEffect, useRef, useState} from "react";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import Switch from "react-bootstrap-switch";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";

// components
import { ButtonCancel, ButtonSubmit, GenericTableButton } from "../../../components/buttons/buttonsActions";
import { LogHistoryModal } from "../../../components/logHistory/logHistoryModal";
import { showLoader } from "../../../components/loader/loader";
import SelectGeneric from "../../../components/select/selectGeneric";
import { showToastCustom } from "../../../components/toast/customToast";

// labels
import {
    error,
    FORM, selectOption,
} from "../../../components/i18n/i18n";
import { TT_HISTORY } from "../../../components/i18n/toolTips";

// services
import {typeSeasonProvider} from "../../../providers/typeSeasonProvider";
import {scheduleService} from "../../../jwt/_services/clasificator/scheduleService";

const ActivityScheduleFrom = props => {
    const { app, parent } = props.mainProps
    const itemToEdit = props.itemToEdit
    const editMode = !!itemToEdit.id
    const [showLoading, setShowLoading] = useState(false);

    const [typeSeasonId, setTypeSeasonId] = useState(itemToEdit?.typeSeason?.id || null);
    const [status, setStatus] = useState( itemToEdit?.status !== undefined ? itemToEdit?.status : false)
    const [time12, setTime12] = useState(itemToEdit?.time12 || null);
    const [time24, setTime24] = useState(itemToEdit?.time24 || null);
    const [duration, setDuration] = useState(itemToEdit?.duration || '')
    const [timeFrom, setTimeFrom] = useState('00:00');
    const [timeTo, setTimeTo] = useState('00:00');

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(itemToEdit);
    }

    useEffect(() => {
        if (itemToEdit?.time24 !== null) {
            separateFromTo(itemToEdit?.time24);
            if (!editMode) {
                setSchedule(timeFrom, timeTo)
            }
        }
    }, []);

    const {register, handleSubmit, errors} = useForm({
        defaultValues: {
            duration: itemToEdit?.duration,
            time12: itemToEdit?.time12,
            time24: itemToEdit?.time24,
            status: itemToEdit?.status,
            season: itemToEdit?.season,
        }
    });

    const onSubmit = async (data, _) => {
        if (typeSeasonId == null)
            return showToastCustom(error, selectOption);

        setShowLoading(true)
        let dataRequest = {
            fbDataBase : { id : app?.fbDataBase?.id },
            item : {
                activity: { id: parent?.id },
                typeSeason: { id: typeSeasonId },
                time12: time12,
                time24: time24,
                status: status,
                duration: data.duration
            }
        };

        // console.log(dataRequest)

        if (editMode) {
            let id = itemToEdit?.id;
            dataRequest.item.id = id
            await scheduleService.updateItem( id, dataRequest)
        } else {
            await scheduleService.saveItem(dataRequest)
        }

        setShowLoading(false)
        closeForm()
    };

    const separateFromTo = (time) => {
        if (time !== undefined) {
            setTimeFrom(time.split('-')[0].trim());
            setTimeTo(time.split('-')[1]?.trim() !== undefined ? time.split('-')[1]?.trim() : '00:00');
        }
    }

    const setSchedule = (from, to) => {
        const fromh24 = from.split(':')[0];
        const fromm24 = from.split(':')[1];

        let toh24 = to.split(':')[0];
        let tom24 = to.split(':')[1];

        if (fromh24 > toh24 || (fromh24 === toh24 && fromm24 > tom24)) {
            to = from;

            toh24 = to.split(':')[0];
            tom24 = to.split(':')[1];
            setTimeTo(to);
        }

        let from12;
        let to12;

        if (fromh24 >= 12) {
            from12 = fromh24 === "12" ? `12:${fromm24} PM` : `${fromh24 - 12}:${fromm24} PM`;
        } else {
            from12 = `${fromh24}:${fromm24} AM`;
        }

        if (toh24 >= 12) {
            to12 = toh24 === "12" ? `12:${tom24} PM` : `${toh24 - 12}:${tom24} PM`;
        } else {
            to12 = `${toh24}:${tom24} AM`;
        }

        if (from === to){
            setTime24(`${from}`);
            setTime12(`${from12}`);
        } else {
            setTime24(`${from} - ${to}`);
            setTime12(`${from12} - ${to12}`);
        }
    }

    function calcularDiferenciaHoras(horaInicial, horaFinal) {
        // Convertir las cadenas de hora en minutos desde la medianoche
        const [horaInicio, minutoInicio] = horaInicial.split(':').map(Number);
        const [horaFin, minutoFin] = horaFinal.split(':').map(Number);

        const minutosInicio = horaInicio * 60 + minutoInicio;
        const minutosFin = horaFin * 60 + minutoFin;

        // Calcular la diferencia en minutos
        let diferenciaMinutos = minutosFin - minutosInicio;

        // Asegurarse de que la diferencia sea positiva y esté en un ciclo de 24 horas
        if (diferenciaMinutos < 0) {
            diferenciaMinutos += 1440; // 24 horas en minutos
        }

        // Calcular horas y minutos
        const horas = Math.floor(diferenciaMinutos / 60);
        const minutos = diferenciaMinutos % 60;

        // Crear una cadena de resultado formateada
        let resultado = '';

        if (horas > 0) {
            resultado += horas === 1 ? '1 hr' : `${horas} hrs`;
        }

        if (minutos > 0) {
            if (resultado.length > 0) {
                resultado += ' ';
            }
            resultado += minutos === 1 ? '1 min' : `${minutos} min`;
        }

        return resultado;
    }

    const onTimeFromChange = (value) => {
        setTimeFrom(value);
        setSchedule(value, timeTo);
        setDuration(calcularDiferenciaHoras(value,timeTo ));
    }

    const onTimeToChange = (value) => {
        setTimeTo(value);
        setSchedule(timeFrom, value);
        setDuration(calcularDiferenciaHoras(timeFrom, value));
    }

    const closeForm = () => {
        props.setShowItem(false)
        props.setItemToEdit({})
    }

    return (<>
        { showLoading && showLoader() }
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label >Desde (24hrs)</Label>
                                <Input type="time" name="timeFrom"
                                       placeholder="Ingrese hora"
                                       innerRef={register}
                                       value={timeFrom}
                                       onChange={e => onTimeFromChange(e.target.value)}
                                       className={(errors.timeFrom ? ' is-invalid' : '')}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label >Hasta (24hrs)</Label>
                                <Input type="time" name="timeTo"
                                       placeholder="Ingrese hora"
                                       innerRef={register}
                                       value={timeTo}
                                       onChange={e => onTimeToChange(e.target.value)}
                                       className={(errors.timeTo ? ' is-invalid' : '')}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="5">
                            <FormGroup>
                                <Label>Tipo de temporada</Label>
                                <SelectGeneric
                                    initialValue={ typeSeasonId || null }
                                    setExternalValue={ setTypeSeasonId }
                                    provider = { typeSeasonProvider }
                                />
                            </FormGroup>
                        </Col>
                        <Col md="5">
                            <FormGroup>
                                <Label>Duración</Label>
                                <Input type="text"
                                       name="duration"
                                       placeholder="Ingrese duración"
                                       value={ duration }
                                       onChange={e => setDuration(e.target.value)}
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Activo</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={status}
                                        innerRef={register}
                                        onChange={_ => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={closeForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>

        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ itemToEdit }
            />
        }
    </>)
}


const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({})

export default connect(mapStateToProps, mapActionsToProps)(ActivityScheduleFrom)